<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-row v-if="!loading">
      <b-col md="12" class="d-flex justify-content-end">
  <!-- 'Visit Website' button -->
  <b-button variant="primary" @click="redirectToStore">
    Visit Website
  </b-button>

  <!-- 'Add Complaint' button (conditionally shown) -->
  <b-button variant="primary"class="ml-2" to="/servicetemplates/add">
    Add Templatess
  </b-button>
</b-col>
      <b-col cols="12" md="2" sm="2" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
        </b-form-group>
      </b-col>
      <b-col md="4" sm="8" class="my-1">
      </b-col>
      <b-col md="6" class="my-1 d-flex justify-content-end">
        <b-button variant="outline-danger"  @click="clearFilters">
          Clear Filters
        </b-button>
      </b-col>

      <b-col cols="12">
        <b-table striped hover responsive :items="filteredService" :fields="fields" :per-page="perPage"
          :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @sort-changed="onSortChanged"
          @filtered="onFiltered">
          <template #head(orderName)>
            <div class="d-flex flex-column">
              <span>Template Name</span> <!-- Add label here -->
              <b-form-input v-model="columnFilters.orderName" placeholder="Search by Name" size="sm"
                @input="filterTable" />
            </div>
          </template>
          <template #head(orderDescription)>
            <div class="d-flex flex-column">
              <span>Description</span> <!-- Add label here -->
              <b-form-input v-model="columnFilters.orderDescription" placeholder="Search by Description" size="sm"
                @input="filterTable" />
            </div>
          </template>
          <template #head(budget)>
            <div class="d-flex flex-column">
              <span>Budget</span> <!-- Add label here -->
              <b-form-input v-model="columnFilters.budget" placeholder="Search by Budget" size="sm" type="number"
                @input="filterTable" />
            </div>
          </template>
          <template #head(estimatedDuration)>
            <div class="d-flex flex-column">
              <span>Estimated Duration</span> <!-- Add label here -->
              <b-form-input v-model="columnFilters.estimatedDuration" placeholder="Search by Duration" size="sm"
                type="number" @input="filterTable" />
            </div>
          </template>
          <template #cell(actions)="data">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template v-slot:button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item :to="getEditUrl(data.item.id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="removeTemplate(data.item.id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="d-flex justify-content-center mb-1">
          <b-spinner variant="success" label="Spinning" block v-if="loading"
            style="width: 3rem; height: 3rem"></b-spinner>
        </div>
      </b-col>

      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
          class="my-0" />
        <b-form-group>
          Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
        </b-form-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      service: [],
      currentPage: 1,
      filter: "",
      columnFilters: {
        orderName: "",
        orderDescription: "",
        budget: "",
        estimatedDuration: ""
      },
      sortBy: '', // Default column to sort
      sortDesc: false,
      items: [
        {
          orderName: 'Template 1',
          orderDescription: 'Description for Template 1',
          budget: 100,
          estimatedDuration: 30
        }
      ],
      fields: [
        { key: "orderName", label: "Template Name", sortable: true },
        { key: "orderDescription", label: "Description", sortable: true },
        { key: "budget", label: "Budget", sortable: true },
        { key: "estimatedDuration", label: "Estimated Duration", sortable: true },
        { key: "actions", label: "Actions" }
      ]

    };
  },
  computed: {
    // sortOptions() {
    //   // Create an options list from our fields
    //   return this.fields
    //     .filter((f) => f.sortable)
    //     .map((f) => ({ text: f.label, value: f.key }));
    // },
    ...mapGetters("serviceModule", {
      servicerequestList: "servicerequests",
      loading: "loading",
    }),
    filteredService() {
      return this.service.filter((item) => {
        return Object.keys(this.columnFilters).every((key) => {
          const filterValue = this.columnFilters[key];
          if (!filterValue) return true; // If no filter, include all
          return String(item[key] || "")
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        });
      });
    }
  },
  watch: {
    columnFilters: {
      deep: true,
      handler() {
        this.currentPage = 1; // Reset to page 1 whenever filters change
      }
    }
  },
  methods: {
    ...mapActions("serviceModule", ["getServiceTemplateListAction", "removeServiceTemplateAction"]),
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    removeTemplate(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeServiceTemplateAction(id)
            .then(() => {
              this.service = this.servicerequestList;
              this.totalRows = this.service.length;
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your template has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Delete Failed!",
                text: error.response.data.message,
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            });
        }
      });
    },
    getEditUrl(id) {
      return "/servicetemplates/edit/" + id;
    },
    filterTable() {
      this.currentPage = 1; // Reset to page 1 whenever a filter is applied
    },
    clearFilters() {
      this.filter = ''; // Clear global search filter
      this.columnFilters = { // Reset individual column filters
        orderName: '',
        orderDescription: '',
        budget: '',
        estimatedDuration: ''
      };
      this.currentPage = 1; // Reset to the first page
    },
    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
    },

    redirectToStore() {
      const tenantName = localStorage.getItem("userTenant");
      if (tenantName) {
        const storeUrl = `${process.env.VUE_APP_CRM_URL}booking/${tenantName}`;

        window.open(storeUrl, "_blank");
      } else {
        alert("Tenant name not found!");
      }
    },
  },
  async mounted() {
    await this.getServiceTemplateListAction().then(() => {
      this.service = this.servicerequestList;
      this.totalRows = this.service.length;
    });
  },
};
</script>